import chalk from 'chalk';
import ora, { Ora } from 'ora';

let _verbose = false;

export const logger = {
  setVerbose: (value: boolean) => { _verbose = value; },
  isVerbose: () => _verbose,

  info: (message: string) => console.log(chalk.blue('ℹ'), message),
  success: (message: string) => console.log(chalk.green('✓'), message),
  warning: (message: string) => console.log(chalk.yellow('⚠'), message),
  error: (message: string) => console.log(chalk.red('✗'), message),
  debug: (message: string) => { if (_verbose) console.log(chalk.gray('⊡'), chalk.gray(message)); },

  header: (title: string) => {
    console.log();
    console.log(chalk.cyan('═'.repeat(60)));
    console.log(chalk.cyan.bold(`  ${title}`));
    console.log(chalk.cyan('═'.repeat(60)));
    console.log();
  },

  step: (current: number, total: number, message: string) => {
    console.log(chalk.gray(`[${current}/${total}]`), message);
  },

  spinner: (text: string): Ora => {
    return ora({ text, color: 'cyan' }).start();
  },

  box: (content: string[], type: 'info' | 'success' | 'warning' | 'error' = 'info') => {
    const colors = {
      info: chalk.cyan,
      success: chalk.green,
      warning: chalk.yellow,
      error: chalk.red,
    };
    const color = colors[type];
    // Strip ANSI codes to get visible length for alignment
    const stripAnsi = (s: string) => s.replace(/\x1B\[[0-9;]*m/g, '');
    const maxLen = Math.max(...content.map((l) => stripAnsi(l).length));
    const border = color('─'.repeat(maxLen + 4));

    console.log();
    console.log(border);
    content.forEach((line) => {
      const pad = maxLen - stripAnsi(line).length;
      console.log(color('│'), line + ' '.repeat(pad), color('│'));
    });
    console.log(border);
    console.log();
  },
};
